import { useState,} from 'react'

export const useShowAll = function(allItems, collapsedSize) {
  const [items, setItems] = useState(allItems.slice(0, collapsedSize))
  const showingAll = items.length >= allItems.length
  const nextItem = showingAll ? null : allItems[collapsedSize]
  const countLeft = showingAll ? 0 : allItems.length - collapsedSize
  const showAll = () => setItems(allItems)
  return [items, showAll, nextItem, countLeft];
}
